import randomAngle from "../helpers/randomAngle";

export default function sameRow(movePath, handleFinalTouchAngle, _column) {
  let touch, next, column;
  let spin; // min - 0 | max - 6

  next = movePath[0]; // 1 - right, 0 - left
  let afterNext = movePath[1]; // 1 - right, 0 - left: ;
  next === "1" ? (column = _column + 1) : (column = _column - 1);
  spin = 1;
  movePath[0] = next === "1" ? "0" : "1";
  let finalAngle = randomAngle(next, afterNext, "sameRow");

  let time = 150 + spin * 50;

  touch = handleFinalTouchAngle(finalAngle);
  return [touch, spin, time, column, movePath, finalAngle];
}
